import useAxios from "axios-hooks";

export const useRewards = () => {
    const [{ data, loading, error }, refetch] = useAxios("/api/rewards");

    return [data, loading, error, refetch];
};
